export const SETTING_OPEN_MODAL = 'SETTING_OPEN_MODAL';
export const SETTING_CLOSE_MODAL = 'SETTING_CLOSE_MODAL';
// ------------------------------------------------------------------------------------------------
